<nav class="footer-nav" fxLayout="row wrap" fxLayout.mm-desktop="row nowrap" fxLayout.mm-tablet-landscape="row nowrap">
  <ul
    class="footer-nav__category footer-nav__large"
    fxFlex="20%"
    fxFlex.mm-tablet="50%"
    fxLayout="column nowrap"
    *ngFor="let navigationLinks of footerLinks"
  >
    <li>
      <p class="footer-nav__heading">{{ navigationLinks?.title | translate }}</p>
    </li>
    <ng-container *ngFor="let link of navigationLinks?.links">
      <li *ngIf="link.externalLink">
        <app-footer-link [link]="link" (linkClicked)="onLinkClicked(link)"> </app-footer-link>
      </li>
    </ng-container>
  </ul>
  <ul
    class="footer-nav__category footer-nav__large footer-nav__category--payments"
    [mmTestTarget]="'footer-nav-payments'"
    fxFlex="20%"
    fxFlex.mm-tablet="50%"
    fxLayout="column nowrap"
  >
    <li>
      <p class="footer-nav__heading footer-nav__heading--payments">
        {{ 'FOOTER.ALL_PAGES.NAVIGATION.PAYMENTS_METHODS.LABEL' | translate }}
      </p>
    </li>
    <li fxFlex="60%" fxLayout="row wrap" fxLayoutAlign="flex-start start">
      <div *ngFor="let imageUrl of links?.footer_for_payments" class="footer-nav__img">
        <img [appLazyLoadImage]="cdnBaseUrl + imageUrl" width="90" height="40" alt="icon" />
      </div>
    </li>
  </ul>
  <div
    class="footer-nav__category footer-nav__large telesales__tablet"
    fxFlex="20%"
    fxFlex.mm-tablet="50%"
    fxLayout="column nowrap"
  >
    <div
      class="telesales__tablet__layout"
      fxLayout="column nowrap"
      fxFlexAlign="flex-start"
      fxLayoutAlign="center center"
    >
      <ul class="telesales-ul">
        <li class="telesales-li"
            fxLayout="row nowrap"
            fxLayoutAlign="center center">
          <p class="footer-nav__heading"
             [attr.aria-label]="'FOOTER.ALL_PAGES.NAVIGATION.TELESALES.TITLE' | translate">
            {{ 'FOOTER.ALL_PAGES.NAVIGATION.TELESALES.TITLE' | translate }}
          </p>
        </li>
        <li
          class="telesales-li"
          fxLayout="row nowrap"
          fxLayoutAlign="start center"
          *ngIf="links?.telesales_phone_number"
          style="width: 100%"
        >
          <div fxLayout="column">
            <p fxLayout="row nowrap" fxLayoutAlign="start center">
              <app-svg-phone class="footer-icon" aria-hidden="true"></app-svg-phone>
              <a (click)="onTelesalesPhoneClick()" [href]="'tel:' + links.telesales_phone_number"
                 [attr.aria-label]="'FOOTER.ALL_PAGES.TELESALES.PHONE_NUMBER.ARIA_LABEL' | translate:{ telesales: links.telesales_phone_number.replace(regExp, '').split('').join(' ') }">
                {{ links.telesales_phone_number }}
              </a>
              <app-tooltip [position]="'left'" class="footer-nav__tooltip"
                           [ariaLabelContent]="removeHTMLTags('FOOTER.ALL_PAGES.NAVIGATION.TELESALES.TOOLTIP' | translate)">
                <span id="business-customers-tooltip-tablet"
                      [innerHTML]="'FOOTER.ALL_PAGES.NAVIGATION.TELESALES.TOOLTIP' | translate"></span>
              </app-tooltip>
            </p>
          </div>
        </li>
        <li class="telesales-li" fxLayout="row nowrap" fxLayoutAlign="start center">
          <div fxLayout="column" fxLayoutAlign="start center">
            <a (click)="onCalendlyClick()"
               [href]="calendlyHref"
               target="_blank"
               rel="noopener noreferrer"
               class="telesales__calendly__button"
               style="width: 100%">
              <div fxLayout="row nowrap" fxLayoutAlign="start center">
                <app-svg-calender class="footer-icon"></app-svg-calender>
                <span class="telesales__calendly__text">
                {{ 'CATALOG.DETAILS_PAGE.TELESALES.BOOK_CALL' | translate }}
              </span>
              </div>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="footer-nav__category footer-nav__large" fxFlex="20%" fxFlex.mm-tablet="50%" fxLayout="column nowrap">
    <ul class="telesales-ul">
      <li>
        <p class="footer-nav__heading"
           [attr.aria-label]="'FOOTER.ALL_PAGES.NAVIGATION.CUSTOMER_SUPPORT.TITLE' | translate">
          {{ 'FOOTER.ALL_PAGES.NAVIGATION.CUSTOMER_SUPPORT.TITLE' | translate }}
        </p>
      </li>
      <li fxLayout="row nowrap" fxLayoutAlign="flex-start center" *ngIf="supportPhoneNoEnabled$ | async">
        <div fxLayout="column">
          <p fxLayout="row nowrap" fxLayoutAlign="flex-start center">
            <app-svg-phone class="footer-icon"></app-svg-phone>
            <a
              [mmTestTarget]="'footer-phone-link'"
              [href]="
              'tel:' +
              (isSubsidiaryAccount
                ? links?.support_phone_number_subsidiary
                : isTier3
                ? links?.support_phone_number_b2b
                : links?.support_phone_number)
            "
              [attr.aria-label]="'FOOTER.ALL_PAGES.B2C.PHONE_NUMBER.ARIA_LABEL' | translate:{ b2c: (isSubsidiaryAccount
                ? links?.support_phone_number_subsidiary
                : isTier3
                ? links?.support_phone_number_b2b
                : links?.support_phone_number).replace(regExp, '').split('').join(' ') }"
          >
            {{
              isSubsidiaryAccount
                ? links?.support_phone_number_subsidiary
                : isTier3
                ? links?.support_phone_number_b2b
                : links?.support_phone_number
            }}
          </a>
          <app-tooltip [ariaLabelContent]="removeHTMLTags('FOOTER.ALL_PAGES.NAVIGATION.KUNDENSERVICE.TOOLTIP' | translate)" [position]="'left'" class="footer-nav__tooltip">
            <span id="footer-customer-service-tooltip-desktop" [innerHTML]="'FOOTER.ALL_PAGES.NAVIGATION.KUNDENSERVICE.TOOLTIP' | translate"></span>
            </app-tooltip>
            <a
                *ngIf="tooltipHref"
                [href]="tooltipHref"
                target="_blank"
                rel="noreferrer"
                class="sr-only"
                data-testid="sr-link-tooltip"
                [attr.aria-label]="'FOOTER.ALL_PAGES.NAVIGATION.KUNDENSERVICE.TOOLTIP.LINK_ARIA_LABEL' | translate"
              >
                {{ tooltipHref }}
            </a>
          </p>
          <p
            *ngIf="!!links?.support_phone_disclaimer"
            [ngClass]="{ 'footer-nav__phone-disclaimer': links?.support_phone_disclaimer }"
          >
            {{ 'FOOTER.ALL_PAGES.NAVIGATION.PHONE.DISCLAIMER' | translate }}
          </p>
        </div>
      </li>
      <li fxLayout="row nowrap" fxLayoutAlign="flex-start center">
        <app-svg-mail class="footer-icon" aria-hidden="true"></app-svg-mail>
        <ng-container *ngIf="!isSubsidiaryAccount; else subsidiaryEmail">
          <a
            [mmTestTarget]="'footer-helpCenter-link'"
            target="_blank"
            rel="noopener noreferrer"
            (click)="onClickBuyerSupport()"
            [href]="links?.help_center_link"
          >{{ 'FOOTER.ALL_PAGES.NAVIGATION.CONTACTS.CONTACT_US.LABEL' | translate }}</a
          >
        </ng-container>
      </li>
      <li fxLayout="row nowrap" fxLayoutAlign="flex-start center">
        <app-svg-news class="footer-icon"></app-svg-news>
        <ng-container>
          <a
            target="_blank"
            rel="noopener noreferrer"
            [mmTestTarget]="'footer-helpCenter-link'"
            [href]="links?.freshdesk_instance_link"
          >
            {{ 'FOOTER.ALL_PAGES.NAVIGATION.NEWS.NOTIFICATION' | translate }}
          </a>
        </ng-container>
      </li>
      <li fxLayout="row nowrap" fxLayoutAlign="flex-start center" *ngIf="isCoBrowserEnabled">
        <app-svg-co-browse class="footer-icon" aria-hidden="true"></app-svg-co-browse>
        <button class="footer-nav__co-browse" (click)="openCoBrowsing()" [mmTestTarget]="'cobrowse_link_on_click'">
          {{ 'FOOTER.ALL_PAGES.NAVIGATION.CO-BROWSING' | translate }}
        </button>
        <app-tooltip [position]="'left'" class="footer-nav__tooltip" [ariaLabelContent]="removeHTMLTags('FOOTER.ALL_PAGES.NAVIGATION.CO-BROWSING_TOOLTIP' | translate)">
          <span id="co-browse" [innerHTML]="'FOOTER.ALL_PAGES.NAVIGATION.CO-BROWSING_TOOLTIP' | translate"></span>
        </app-tooltip>
      </li>
    </ul>
    <div class="telesales__layout" fxLayout="column nowrap" fxFlexAlign="flex-start" fxLayoutAlign="center center">
      <ul class="telesales-ul">
        <li class="telesales-li"
            fxLayout="row nowrap"
            fxLayoutAlign="center center">
          <p class="footer-nav__heading"
             [attr.aria-label]="'FOOTER.ALL_PAGES.NAVIGATION.BUSINESS_CUSTOMER_SUPPORT.TITLE' | translate">
            {{ 'FOOTER.ALL_PAGES.NAVIGATION.BUSINESS_CUSTOMER_SUPPORT.TITLE' | translate }}
          </p>
        </li>
        <li
          class="telesales-li"
          fxLayout="row nowrap"
          fxLayoutAlign="center center"
          *ngIf="links?.telesales_phone_number"
        >
          <div fxLayout="column" style="width: 100%">
            <p fxLayout="row nowrap" fxLayoutAlign="start center">
              <app-svg-phone class="footer-icon"></app-svg-phone>
              <a (click)="onTelesalesPhoneClick()" [href]="'tel:' + links.telesales_phone_number"
                 [attr.aria-label]="'FOOTER.ALL_PAGES.TELESALES.PHONE_NUMBER.ARIA_LABEL' | translate:{ telesales: links.telesales_phone_number.replace(regExp, '').split('').join(' ') }">
                {{ links.telesales_phone_number }}
              </a>
              <app-tooltip [position]="'left'" class="footer-nav__tooltip"
                           [ariaLabelContent]="removeHTMLTags('FOOTER.ALL_PAGES.NAVIGATION.TELESALES.TOOLTIP' | translate)">
                <span id="business-customers-tooltip"
                      [innerHTML]="'FOOTER.ALL_PAGES.NAVIGATION.TELESALES.TOOLTIP' | translate"></span>
              </app-tooltip>
            </p>
          </div>
        </li>
        <li class="telesales-li" fxLayout="row nowrap" fxLayoutAlign="center center">
          <div fxLayout="column" fxLayoutAlign="start center" style="width: 100%">
            <a (click)="onCalendlyClick()"
               class="telesales__calendly__button"
               style="width: 100%"
               [href]="calendlyHref"
               target="_blank">
              <div fxLayout="row" fxLayoutAlign="start center" style="width: 100%">
                <app-svg-calender class="footer-icon"></app-svg-calender>
                <span class="telesales__calendly__text">
                {{ 'CATALOG.DETAILS_PAGE.TELESALES.BOOK_CALL' | translate }}
              </span>
              </div>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <span class="footer-nav__mobile">
    <mm-expansion fxFlex="100%" togglerPosition="left" *ngFor="let navigationLinks of footerLinks">
      <mm-expansion-title>
        <p class="footer-nav__heading">{{ navigationLinks?.title | translate }}</p>
      </mm-expansion-title>
      <ul class="footer-nav__category" fxFlex="100%" fxLayout="column nowrap">
        <ng-container *ngFor="let link of navigationLinks?.links">
          <li *ngIf="link.externalLink">
            <app-footer-link [link]="link" (linkClicked)="onLinkClicked(link)"> </app-footer-link>
          </li>
        </ng-container>
      </ul>
    </mm-expansion>
    <mm-expansion fxFlex="100%" togglerPosition="left">
      <mm-expansion-title>
        <p class="footer-nav__heading">
          {{ 'FOOTER.ALL_PAGES.NAVIGATION.PAYMENTS_METHODS.LABEL' | translate }}
        </p>
      </mm-expansion-title>
      <ul class="footer-nav__category footer-nav__category--payments" fxFlex="200px" fxLayout="column nowrap">
        <li fxFlex="row nowrap" fxLayout="row wrap" fxLayoutAlign="flex-start center">
          <div *ngFor="let imageUrl of links?.footer_for_payments" class="footer-nav__img">
            <img [appLazyLoadImage]="cdnBaseUrl + imageUrl" alt="" />
          </div>
        </li>
      </ul>
    </mm-expansion>
    <mm-expansion fxFlex="100%" togglerPosition="left">
      <mm-expansion-title>
        <p class="footer-nav__heading"
           [attr.aria-label]="'FOOTER.ALL_PAGES.NAVIGATION.CUSTOMER_SUPPORT.TITLE' | translate">
          {{ 'FOOTER.ALL_PAGES.NAVIGATION.CUSTOMER_SUPPORT.TITLE' | translate }}
        </p>
      </mm-expansion-title>
      <ul class="footer-nav__category" fxFlex="100%" fxLayout="column nowrap">
        <li fxLayout="row nowrap" fxLayoutAlign="flex-start center">
          <div fxLayout="column">
            <p fxLayout="row nowrap" fxLayoutAlign="flex-start center" *ngIf="supportPhoneNoEnabled$ | async">
              <app-svg-phone class="footer-icon"></app-svg-phone>
              <a
                [mmTestTarget]="'footer-phone-link'"
                [href]="
                  'tel:' +
                  (isSubsidiaryAccount
                    ? links?.support_phone_number_subsidiary
                    : isTier3
                    ? links?.support_phone_number_b2b
                    : links?.support_phone_number)
                "
                [attr.aria-label]="'FOOTER.ALL_PAGES.B2C.PHONE_NUMBER.ARIA_LABEL' | translate:{ b2c: (isSubsidiaryAccount
                    ? links?.support_phone_number_subsidiary
                    : isTier3
                    ? links?.support_phone_number_b2b
                    : links?.support_phone_number).replace(regExp, '').split('').join(' ') }"
              >
                {{
                  isSubsidiaryAccount
                    ? links?.support_phone_number_subsidiary
                    : isTier3
                      ? links?.support_phone_number_b2b
                      : links?.support_phone_number
                }}
              </a>
              <app-tooltip
                [ariaLabelContent]="removeHTMLTags('FOOTER.ALL_PAGES.NAVIGATION.KUNDENSERVICE.TOOLTIP' | translate)"
                [position]="'left'" class="footer-nav__tooltip">
                <span id="footer-contact-tooltip-mobile"
                      [innerHTML]="'FOOTER.ALL_PAGES.NAVIGATION.KUNDENSERVICE.TOOLTIP' | translate"></span>
              </app-tooltip>
              <a
                *ngIf="tooltipHref"
                [href]="tooltipHref"
                target="_blank"
                rel="noreferrer"
                class="sr-only"
                data-testid="sr-link-tooltip"
                [attr.aria-label]="'FOOTER.ALL_PAGES.NAVIGATION.KUNDENSERVICE.TOOLTIP.LINK_ARIA_LABEL' | translate"
              >
                {{ tooltipHref }}
              </a>
            </p>
            <p
              *ngIf="!!links?.support_phone_disclaimer"
              [ngClass]="{ 'footer-nav__phone-disclaimer': links?.support_phone_disclaimer }"
            >
              {{ 'FOOTER.ALL_PAGES.NAVIGATION.PHONE.DISCLAIMER' | translate }}
            </p>
          </div>
        </li>
        <li fxFlex="row nowrap" fxLayoutAlign="flex-start center">
          <app-svg-mail class="footer-icon"></app-svg-mail>
          <ng-container *ngIf="!isSubsidiaryAccount; else subsidiaryEmail">
            <a
              target="_blank"
              rel="noopener noreferrer"
              [mmTestTarget]="'footer-helpCenter-link'"
              (click)="onClickBuyerSupport()"
              [href]="links?.help_center_link"
            >
              {{ 'FOOTER.ALL_PAGES.NAVIGATION.CONTACTS.CONTACT_US.LABEL' | translate }}
            </a>
          </ng-container>
        </li>
        <li fxFlex="row nowrap" fxLayoutAlign="flex-start center">
          <app-svg-news class="footer-icon"></app-svg-news>
          <ng-container>
            <a
              target="_blank"
              rel="noopener noreferrer"
              [mmTestTarget]="'footer-helpCenter-link'"
              [href]="links?.freshdesk_instance_link"
            >
              {{ 'FOOTER.ALL_PAGES.NAVIGATION.NEWS.NOTIFICATION' | translate }}
            </a>
          </ng-container>
        </li>
      </ul>
    </mm-expansion>
    <mm-expansion fxFlex="100%" togglerPosition="left">
      <mm-expansion-title>
        <p class="footer-nav__heading"
           [attr.aria-label]="'FOOTER.ALL_PAGES.NAVIGATION.BUSINESS_CUSTOMER_SUPPORT.TITLE' | translate">
          {{ 'FOOTER.ALL_PAGES.NAVIGATION.BUSINESS_CUSTOMER_SUPPORT.TITLE' | translate }}
        </p>
      </mm-expansion-title>
      <div class="footer-nav__category telesales__mobile" fxFlex="100%" fxLayout="column nowrap">
        <div
          class="telesales__mobile__layout"
          fxLayout="column nowrap"
          fxFlexAlign="flex-start"
          fxLayoutAlign="center center"
        >
          <ul class="telesales-ul">
            <li
              class="telesales-li"
              fxLayout="row nowrap"
              fxLayoutAlign="start center"
              *ngIf="links?.telesales_phone_number"
            >
            <div fxLayout="column">
              <p fxLayout="row nowrap" fxLayoutAlign="start center">
                <app-svg-phone class="footer-icon"></app-svg-phone>
                <a (click)="onTelesalesPhoneClick()" [href]="'tel:' + links.telesales_phone_number"
                   [attr.aria-label]="'FOOTER.ALL_PAGES.TELESALES.PHONE_NUMBER.ARIA_LABEL' | translate:{ telesales: links.telesales_phone_number.replace(regExp, '').split('').join(' ') }">
                  {{ links.telesales_phone_number }}
                </a>
                <app-tooltip [position]="'left'" class="footer-nav__tooltip"
                             [ariaLabelContent]="removeHTMLTags('FOOTER.ALL_PAGES.NAVIGATION.TELESALES.TOOLTIP' | translate)">
                <span id="business-customers-tooltip-mobile"
                      [innerHTML]="'FOOTER.ALL_PAGES.NAVIGATION.TELESALES.TOOLTIP' | translate"></span>
              </app-tooltip>
              </p>
            </div>
          </li>
            <li class="telesales-li" fxLayout="row nowrap" fxLayoutAlign="start center">
            <div fxLayout="column">
              <a
                [href]="calendlyHref"
                target="_blank"
                rel="noopener noreferrer"
                (click)="onCalendlyClick()"
                class="telesales__calendly__button"
              >
                <div fxLayout="row nowrap" fxLayoutAlign="flex-start center">
                  <app-svg-calender class="footer-icon"></app-svg-calender>
                  <span class="telesales__calendly__text">
                    {{ 'CATALOG.DETAILS_PAGE.TELESALES.BOOK_CALL' | translate }}
                  </span>
                </div>
              </a>
            </div>
          </li>
          </ul>
        </div>
      </div>
    </mm-expansion>
  </span>
</nav>

<ng-template #subsidiaryEmail>
  <a target="_blank" rel="noopener noreferrer" [href]="links?.subsidiary_contact_email">
    {{ 'REGULAR.EMAIL' | translate }}
  </a>
</ng-template>
